import { useQuery } from 'react-query';
import { productService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useProductNameList = () => {
  return useQuery(
    `${ServerStateKeysEnum.productNameList}`,
    () => {
      return productService.getProductNameList();
    },
    { staleTime: Infinity }
  );
};
